"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidAndSelected = exports.isValidAndSelectedById = exports.validateModifierDependencies = exports.validateOverrides = exports.isModifierGroupValid = exports.isModifierValid = exports.findModifierInStructure = void 0;
const modifierGroup_1 = require("./modifierGroup");
const selections_1 = require("./selections");
const findModifierInStructure = (structure, modifierId) => {
    let modifier = null;
    let group = null;
    structure === null || structure === void 0 ? void 0 : structure.forEach((category) => {
        var _a;
        (_a = category === null || category === void 0 ? void 0 : category.fullModifierGroups) === null || _a === void 0 ? void 0 : _a.forEach((modifierGroup) => {
            const find = modifierGroup === null || modifierGroup === void 0 ? void 0 : modifierGroup.fullModifiers.find((m) => {
                return m.id === modifierId;
            });
            if (find) {
                group = modifierGroup;
                modifier = find;
            }
        });
    });
    if (!modifier) {
        return null;
    }
    return {
        modifier: modifier,
        modifierGroup: group,
    };
};
exports.findModifierInStructure = findModifierInStructure;
const isModifierValid = (fullStructure, modifierGroup, modifier, selections) => {
    var _a, _b, _c;
    const modifierOverrides = (_c = (_b = (_a = modifierGroup === null || modifierGroup === void 0 ? void 0 : modifierGroup.modifierOverrides) === null || _a === void 0 ? void 0 : _a[modifier === null || modifier === void 0 ? void 0 : modifier.id]) === null || _b === void 0 ? void 0 : _b.dependencies) !== null && _c !== void 0 ? _c : [];
    const isGroupValid = (0, exports.isModifierGroupValid)(fullStructure, modifierGroup, selections);
    const isValid = (0, exports.validateModifierDependencies)(fullStructure, modifierOverrides, selections);
    return isGroupValid && isValid;
};
exports.isModifierValid = isModifierValid;
const isModifierGroupValid = (fullStructure, modifierGroup, selections) => {
    if (!modifierGroup || !(modifierGroup === null || modifierGroup === void 0 ? void 0 : modifierGroup.id)) {
        return false;
    }
    const overrides = (0, modifierGroup_1.getAllModifierGroupOverridesFromCategories)(fullStructure, modifierGroup);
    return (0, exports.validateOverrides)(fullStructure, modifierGroup, selections, overrides);
};
exports.isModifierGroupValid = isModifierGroupValid;
const validateOverrides = (fullStructure, modifierGroup, selections, overrides) => {
    if (hasDependencies(overrides)) {
        const dependencies = overrides === null || overrides === void 0 ? void 0 : overrides.dependencies;
        return (0, exports.validateModifierDependencies)(fullStructure, dependencies, selections);
    }
    else {
        // Deprecated dependency approach, but still present
        let reqModifiers = {};
        if (hasOverrideRequirements(overrides)) {
            reqModifiers = overrides.requiredModifiers;
        }
        else if (hasParentModifierRequirements(modifierGroup)) {
            reqModifiers = modifierGroup.parentModifiers;
        }
        let isValid = true;
        for (const modifierId of Object.keys(reqModifiers)) {
            if (!(0, exports.isValidAndSelectedById)(fullStructure, modifierId, selections)) {
                isValid = false;
            }
        }
        return isValid;
    }
};
exports.validateOverrides = validateOverrides;
const hasDependencies = (overrides) => {
    return (overrides === null || overrides === void 0 ? void 0 : overrides.dependencies) != null && overrides.dependencies.length > 0;
};
const hasOverrideRequirements = (overrides) => {
    return ((overrides === null || overrides === void 0 ? void 0 : overrides.requiredModifiers) != null &&
        Object.keys(overrides === null || overrides === void 0 ? void 0 : overrides.requiredModifiers).length > 0);
};
const hasParentModifierRequirements = (modifierGroup) => {
    return ((modifierGroup === null || modifierGroup === void 0 ? void 0 : modifierGroup.parentModifiers) != null &&
        Object.keys(modifierGroup === null || modifierGroup === void 0 ? void 0 : modifierGroup.parentModifiers).length > 0);
};
const validateModifierDependencies = (fullStructure, dependencies, selections) => {
    const showDependencies = dependencies.filter((dependency) => dependency.visibility === "show");
    const shouldShow = showDependencies.some((dependency) => validateModifierDependency(fullStructure, dependency, selections));
    const hideDependencies = dependencies.filter((dependency) => dependency.visibility === "hide");
    const shouldHide = hideDependencies.some((dependency) => validateModifierDependency(fullStructure, dependency, selections));
    const hasHideDependencies = (hideDependencies === null || hideDependencies === void 0 ? void 0 : hideDependencies.length) > 0;
    const hasShowDependencies = (showDependencies === null || showDependencies === void 0 ? void 0 : showDependencies.length) > 0;
    if (hasHideDependencies && shouldHide) {
        console.log("Should hide");
        return false;
    }
    else if (hasShowDependencies && shouldShow) {
        console.log("Should show");
        return true;
    }
    else if (!hasShowDependencies) {
        console.log("Should show by default");
        return true;
    }
    else {
        console.log("Hide by default");
        return false;
    }
};
exports.validateModifierDependencies = validateModifierDependencies;
const validateModifierDependency = (fullStructure, dependency, selections) => {
    let isValid;
    if (dependency.condition === "any") {
        isValid = Object.keys(dependency.requiredModifiers).some((modifierId) => {
            return (0, exports.isValidAndSelectedById)(fullStructure, modifierId, selections);
        });
    }
    else {
        isValid = Object.keys(dependency.requiredModifiers).every((modifierId) => {
            return (0, exports.isValidAndSelectedById)(fullStructure, modifierId, selections);
        });
    }
    return isValid;
};
const isValidAndSelectedById = (fullStructure, modifierId, selections) => {
    if (!modifierId) {
        return false;
    }
    const modifierInfo = (0, exports.findModifierInStructure)(fullStructure, modifierId);
    if (!modifierInfo) {
        return false;
    }
    return (0, exports.isValidAndSelected)(fullStructure, modifierInfo === null || modifierInfo === void 0 ? void 0 : modifierInfo.modifierGroup, modifierInfo === null || modifierInfo === void 0 ? void 0 : modifierInfo.modifier, selections);
};
exports.isValidAndSelectedById = isValidAndSelectedById;
const isValidAndSelected = (fullStructure, modifierGroup, modifier, selections) => {
    return ((0, exports.isModifierValid)(fullStructure, modifierGroup, modifier, selections) &&
        (0, selections_1.isModifierSelected)(modifier === null || modifier === void 0 ? void 0 : modifier.id, selections));
};
exports.isValidAndSelected = isValidAndSelected;
//# sourceMappingURL=validation.js.map